<template>
  <div class="comp-inquiry-progress-extended">
    <div>
      <ProgressCircle :progress="progressInquiry"/>
      <span :class="{ complete: progressInquiry >= 1 }"/>
      <ProgressCircle :progress="progressReview"/>
      <span :class="{ complete: progressReview >= 1 }" />
      <ProgressCircle :progress="progressCompletion"/>
      <span :class="{ complete: progressCompletion >= 1 }" />
      <!--
      <ProgressCircle :progress="progressAnonymizing" />
      <span :class="{ complete: progressAnonymizing >= 1 }"/>
      -->
      <ProgressCircle :progress="progressArchived" />
    </div>
    <div>
      <span
        v-for="str in statusStrings"
        :key="str">
        {{ str }}
      </span>
    </div>
  </div>
</template>

<script>
  import InquiryStatus from '@/objects/InquiryStatus';
  import ProgressCircle from '@/components/ui/ProgressCircle';

  export default {
    name: 'InquiryProgressExtended',
    components: {
      ProgressCircle,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      inquiry: {
        type: Number,
        default: 0,
      },
      status: {
        type: String,
        default: 'open',
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      statusStrings() {
        const strings = this.$i18n.t('inquiry.statusExtProgressStrings');
        return strings[this.status];
      },
      progressInquiry() {
        const status = this.status;
        if ([InquiryStatus.OPEN, InquiryStatus.PROGRESS, InquiryStatus.PROGRESS_COMPLETE].includes(status)) {
          return this.inquiry;
        }
        return 1;
      },
      progressReview() {
        const status = this.status;
        if (status === InquiryStatus.REVIEWING) {
          return 0.65;
        }
        if ([
          InquiryStatus.REVIEWED,
          InquiryStatus.CLOSED,
          InquiryStatus.ANONYMIZING,
          InquiryStatus.ANONYMIZED,
          InquiryStatus.ARCHIVED,
        ].includes(status)) {
          return 1;
        }
        return 0;
      },
      progressCompletion() {
        const status = this.status;
        if (status === InquiryStatus.REVIEWED) {
          return 0.65;
        }
        if ([
          InquiryStatus.CLOSED,
          InquiryStatus.ANONYMIZING,
          InquiryStatus.ANONYMIZED,
          InquiryStatus.ARCHIVED,
        ].includes(status)) {
          return 1;
        }
        return 0;
      },
      progressAnonymizing() {
        const status = this.status;
        if (status === InquiryStatus.ANONYMIZING) {
          return 0.65;
        }
        if ([
          InquiryStatus.ANONYMIZED,
          InquiryStatus.ARCHIVED,
        ].includes(status)) {
          return 1;
        }
        return 0;
      },
      progressArchived() {
        const status = this.status;
        if (status === InquiryStatus.ARCHIVED) {
          return 1;
        }
        return 0;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-inquiry-progress-extended {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  & > div:nth-child(1) {
    display: inline-flex;
    align-items: center;
    & > span {
      width: 65px;
      height: 2px;
      border-radius: 2px;
      margin: 0 4px;
      background-color: $color-black-alpha-10;

      &.complete {
        background-color: $color-signal-green;
      }
    }
  }
  & > div:nth-child(2) {
    margin-top: 4px;
    display: flex;
    width: calc(100% + 50px);
    justify-content: space-between;

    & > span {
      width: 20%;
      text-align: center;
      @include font-body-small;
      color: $color-black-alpha-60;
    }
  }
}
</style>
